import { Component, OnInit, OnDestroy, ViewChild, Inject, ComponentFactoryResolver } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ServerService } from '../../service/server/server.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import Num2persian from 'num2persian';


@Component({
  selector: 'app-weight-detaile',
  templateUrl: './weight-detaile.component.html',
  styleUrls: ['./weight-detaile.component.scss']
})
export class WeightDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any | undefined;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  title: string | undefined;
  lang: any = 1;
  id: number | undefined;
  cate2: number | undefined;
  tip: number | undefined;
  user_info: any | undefined;
  user_id: number | undefined;
  form1: FormGroup;
  public mat_table_hoverRow: any;
  mat_table_selectedRow: any;
  public dataSource: any | undefined;
  displayedColumns = ['row', 'title', 'number', 'operation'];


  constructor(public serverService: ServerService, public router: Router, private matSnackBar: MatSnackBar
    , private matDialogRef: MatDialogRef<WeightDetaileComponent>, private dialog: MatDialog
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any) {
    this.id = dialog_data.id;
    this.cate2 = dialog_data.cate2;
    this.tip = dialog_data.tip;
  }//end consructor

  ngOnInit() {
    this.lang = localStorage.getItem('lang');
    this.user_info = JSON.parse(<any>localStorage.getItem("user_info"));
    this.user_id = this.user_info.user_id;
    this.form1 = new FormGroup({
      'amount': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,}')]),
      'weight_title': new FormControl(null),
      'weight': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,}')])
    })
    this.get_data();
  }

  get_data(): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 10638, cate2: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.form1.patchValue({
              'amount': res['result'][0].meter_cate2_amount,
              'weight': res['result'][0].wharehouse_weight_id,
              'weight_title': res['result'][0].wharehouse_weight_title,
            })
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if 
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  update() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1.valid) {
      return false;
    }
    this.loading = true;
    var obj = {
      address: 10639
      , weight: this.form1.value.weight
      , amount: this.form1.value.amount
      , id: this.id
      , cate2: this.cate2
      , tip: this.tip
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(res['result'][0])
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "این واحد اندازه گیری قبلا اضافه شده است";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  //*******************************************************************************
  load_services(id: number) {
    var where = "";
    var code_id;
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 218) {
            this.form1.patchValue({
              'weight': res.id,
              'weight_title': res.title
            })
          }
        }
      }
    )
  }


  reset_input(id: number) {
    if (id == 218) {
      this.form1.patchValue({
        'weight': null,
        'weight_title': null
      })
    }
  }


  close() {
    this.matDialogRef.close();
  }

  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 2000 });
    }//end if
    else {
      this.matSnackBar.dismiss();
    }
  }

  message(validation: boolean, message: string, type: number, action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
